import * as React from "react";
import { cn } from "@/shared/lib/utils";

import LeftIcon from "@/assets/icons/arrow/leftBlack.svg?react";
import RightIcon from "@/assets/icons/arrow/rightBlack.svg?react";

interface ISliderArrowButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string
    arrow: 'right' | 'left'
}

const SliderArrowButton = React.forwardRef<HTMLButtonElement, ISliderArrowButtonProps>(
    ({ className, arrow, ...props }, ref) => {

        const [pressed, setPressed] = React.useState<boolean>(false);
        const [hovered, setHovered] = React.useState<boolean>(false);

        return (
            <button
                ref={ref}
                className={cn(
                    "bg-white rounded-full w-[44px] h-[44px] flex justify-center items-center transition-all ease-linear duration-200",
                    className,
                    hovered && 'bg-white-80',
                    pressed && 'bg-light-blue'
                )}
                {...props}
                onMouseDown={()=>setPressed(true)}
                onMouseUp={()=>setPressed(false)}
                onMouseEnter={()=>setHovered(true)}
                onMouseLeave={()=>{setPressed(false); setHovered(false)}}
                
                onTouchStart={()=>setPressed(true)}
                onTouchEnd={()=>setPressed(false)}
            >
                {
                    arrow === 'left'? <LeftIcon className="w-[9px] h-[17px]"/>
                    : arrow === 'right'? <RightIcon className="w-[9px] h-[17px]"/>
                    : null
                }
            </button>
        );
    }
);

SliderArrowButton.displayName = "SliderArrowButton";

export default SliderArrowButton;